import axios from 'axios'
import {LogUrls} from './urls'
import router from '../../router'

export default {
  get_all_logs (context) {
    axios.get(LogUrls.getAllLogs + '?page=1&items=20&expand=true').then(function (response) {
      context.commit('GET_ALL_LOGS', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_ALL_LOGS', data)
    })
  },
  get_auth_logs (context) {
    axios.get(LogUrls.authLogs + "?page=1&items=20").then(function (response) {
      context.commit('GET_AUTH_LOGS', response.data)
    })
  },
  get_more_auth_logs(context,page) {
    axios.get(
      LogUrls.authLogs + "?page=" + page + "&items=30"
    ).then(function(response) {
      context.commit("GET_MORE_AUTH_LOGS", response.data);
    });
  },
  get_feature_logs (context) {
    axios.get(LogUrls._featureLogs+ "?page=1&items=20").then(function (response) {
      context.commit('GET_FEATURE_LOGS', response.data)
    })
  },
  get_more_feature_logs (context,page) {
    axios.get(LogUrls._featureLogs+ "?page=" + page + "&items=30").then(function (response) {
      context.commit('GET_MORE_FEATURE_LOGS', response.data)
    })
  },
  get_password_reset_logs (context) {
    axios.get(LogUrls._passwordResetLogs+ "?page=1&items=20").then(function (response) {
      context.commit('GET_PASSWORD_RESETS', response.data)
    })
  },
  get_more_password_reset_logs (context, page) {
    axios.get(LogUrls._passwordResetLogs+ "?page=" + page + "&items=30").then(function (response) {
      context.commit('GET_MORE_PASSWORD_RESETS', response.data)
    })
  },
  get_deleted_logs (context) {
    axios.get(LogUrls.getDeletedLogs).then(function (response) {
      context.commit('GET_DELETED_LOGS', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_DELETED_LOGS', data)
    })
  },
  get_log (context, publicId) {
    axios.get(LogUrls.getLog + publicId).then(function (response) {
      context.commit('GET_LOG', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_LOG', data)
    })
  },
  post_log (context, data) {
    axios.post(LogUrls.postLog, data).then(function (response) {
      context.dispatch('get_all_logs')
      router.push({
        name: data.redirect_url
      })
    })
  },
  update_log (context, data) {
    axios.patch(LogUrls.editLog, data).then(function (response) {
      context.dispatch('get_all_logs')
      router.push({
        name: data.redirect_url
      })
     })
  },
  delete_log (context, publicId) {
    axios.delete(LogUrls.deleteLog + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_LOGS', response.data)
      router.push({
        name: 'Module.DeletedLogs'
      })
    })
  },
  restore_log (context, publicId) {
    axios.get(LogUrls.restoreLog + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_LOGS', response.data)
      router.push({
        name: 'Module.Logs'
      })
    })
  },
  get_change_log (context) {
    axios.get(LogUrls.getChangeLog).then(function (response) {
      context.commit('GET_CHANGE_LOG', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_CHANGE_LOG', data)
    })
  },
  get_single_change_log (context) {
    axios.get(LogUrls.getSingleChangeLog).then(function (response) {
      context.commit('GET_SINGLE_CHANGE_LOG', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_SINGLE_CHANGE_LOG', data)
    })
  },
  post_change_log (context, data) {
    axios.post(LogUrls.postChangeLog, data).then(function (response) {
      context.dispatch('get_change_log')
      router.push({
        name: Changelog
      })
    })
  },
  post_system_log (context, data) {
    axios.post(LogUrls.saveSystemLogs, data).then(function (response) {
      context.dispatch('get_change_log')
     
    })
  },

}
